import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router';
import axios from 'axios';
import mitt from 'mitt';
import Antd from 'ant-design-vue';
import { ElMessage } from 'element-plus'

import 'element-plus/dist/index.css'
import './assets/styles/common.css';
import './assets/styles/components/table.css';
import './assets/styles/components/button.css';
import './assets/styles/components/form.css';
import './assets/styles/components/nav.css';
import './assets/styles/views/login.css';
import './assets/styles/views/dashboard.css';
import './assets/styles/views/students.css';
import './assets/styles/views/teachers.css';
import './assets/styles/views/information-editing.css';
import './assets/styles/views/dashboard-home.css';
import './assets/styles/views/information-editing-second.css';


const eventBus = {
  listeners: {},
  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  },
  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => callback(data));
    }
  },
  off(event) {
    if (this.listeners[event]) {
      delete this.listeners[event];
    }
  }
};

const app = createApp(App);
app.use(ElementPlus, {
  size: 'default',
  zIndex: 3000
});
app.config.globalProperties.$bus = eventBus;
app.config.globalProperties.$message = ElMessage;

const axiosInstance = axios.create({
  baseURL: 'http://xiaomaibo.cn/api',
  timeout: 5000
})

app.config.globalProperties.$axios = axiosInstance
const emitter = mitt();
app.config.globalProperties.eventBus = emitter;
app.config.globalProperties.$bus = emitter;

app.use(ElementPlus);

axios.defaults.baseURL = 'http://xiaomaibo.cn/api'

app.use(Antd);
app.use(router);

const debounce = (fn, delay) => {
  let timeoutId
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    timeoutId = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

window.addEventListener('error', e => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const resizeObserverErr = e
    resizeObserverErr.stopImmediatePropagation()
  }
}, true)

if (window.ResizeObserver) {
  window.ResizeObserver = class ResizeObserver extends window.ResizeObserver {
    constructor(callback) {
      super(debounce(callback, 20))
    }
  }
}

app.mount('#app');


